import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthState } from '../store/auth/auth.reducer';
import { Observable } from 'rxjs';
import authActions from '../store/auth/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class StoreAuthService {

  constructor(private store: Store<{ auth: AuthState }>) { }

  getAuthToken(): Observable<string | null> {
    return this.store.select(state => state?.auth?.token);
  }

  setAuthToken(token: string): void {
    this.store.dispatch(authActions.setToken({ token }))
  }

  clearAuthToken(): void {
    this.store.dispatch(authActions.clearToken())
  }

  getUserData(): Observable<any | null> {
    return this.store.select(state => state?.auth?.user);
  }

  setUserData(user: any): void {
    this.store.dispatch(authActions.setUser({ user }))
  }

  clearUserData(): void {
    this.store.dispatch(authActions.clearUser())
  }
}
